export default "__VITE_ASSET___OtSP4eC__"